import api from "./api";
import { ensureArray } from "../utils/plantillas";

const API_URL = "/productos";

// normalize product object: ensure .items is always an array and inner componente.items too
const normalizeProducto = (p) => {
    if (!p) return p;
    const copy = { ...p };
    copy.items = ensureArray(p.items);
    // if items are components that themselves have items, normalize them too
    copy.items = copy.items.map((it) => {
        if (it && typeof it === 'object') {
            return { ...it, items: ensureArray(it.items) };
        }
        return it;
    });
    // normalize componentes and their inner items as well
    copy.componentes = ensureArray(p.componentes);
    copy.componentes = copy.componentes.map((c) => {
        if (c && typeof c === 'object') {
            return { ...c, items: ensureArray(c.items) };
        }
        return c;
    });
    return copy;
};

export const getProductos = async () => {
    const res = await api.get(API_URL);
    const data = res.data || [];
    if (Array.isArray(data)) return data.map(normalizeProducto);
    // if backend returned a map/object, convert to values
    return Object.values(data).map(normalizeProducto);
};

export const createProducto = async (producto) => {
    const res = await api.post(API_URL, producto);
    return normalizeProducto(res.data);
};

export const deleteProducto = async (id) => {
    await api.delete(`${API_URL}/${id}`);
};

export const getProductoById = async (id) => {
    const res = await api.get(`${API_URL}/${id}`);
    return normalizeProducto(res.data);
};